import { render, staticRenderFns } from "./RulesOfUserConduct.pug?vue&type=template&id=5ac0f1e2&lang=pug&"
import script from "./RulesOfUserConduct.vue?vue&type=script&lang=js&"
export * from "./RulesOfUserConduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports